import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, FileSignature, Loader2 } from "lucide-react";
import parentApi from "@/lib/parentApi";
import { ParentFormFill, ParentFormRows } from "@/components/parent/ParentFormFill";

export default function ParentFormsPage() {
  const nav = useNavigate();
  const [sends, setSends] = useState(null);
  const [open, setOpen] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await parentApi.get("/parent/forms");
      setSends(data);
    } catch {
      nav("/parent/login");
    }
  }, [nav]);

  useEffect(() => {
    if (!localStorage.getItem("vlog_parent_token")) { nav("/parent/login"); return; }
    load();
  }, [load, nav]);

  return (
    <div className="flex-1 bg-slate-50" data-testid="parent-forms-page">
      <header className="bg-white border-b border-slate-200 text-slate-900 px-5 py-4">
        <div className="max-w-2xl mx-auto flex items-center gap-3">
          <button onClick={() => open ? setOpen(null) : nav("/parent")} data-testid="parent-forms-back" className="h-9 w-9 rounded-lg border border-slate-200 bg-white text-slate-700 inline-flex items-center justify-center hover:bg-slate-100">
            <ArrowLeft className="h-4 w-4" />
          </button>
          <div className="h-9 w-9 rounded-xl bg-indigo-500/20 flex items-center justify-center"><FileSignature className="h-4 w-4 text-indigo-300" /></div>
          <div>
            <div className="font-display font-bold leading-tight">Forms</div>
            <div className="text-[11px] text-slate-500">Fill & e-sign school forms</div>
          </div>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-4 space-y-3">
        {sends === null && <div className="rounded-2xl bg-white p-10 text-center shadow-sm"><Loader2 className="h-6 w-6 animate-spin mx-auto text-slate-400" /></div>}
        {open ? (
          <ParentFormFill send={open} onClose={() => setOpen(null)} onDone={() => { setOpen(null); load(); }} />
        ) : (
          <>
            {sends !== null && sends.length === 0 && (
              <div className="rounded-2xl bg-white p-8 text-center shadow-sm text-sm text-slate-500" data-testid="parent-forms-empty">No forms yet.</div>
            )}
            <ParentFormRows sends={sends || []} onOpen={setOpen} showStudent />
          </>
        )}
      </main>
    </div>
  );
}
